import { render, staticRenderFns } from "./SliceIframeEmbed.vue?vue&type=template&id=6542825f&scoped=true"
import script from "./SliceIframeEmbed.vue?vue&type=script&lang=js"
export * from "./SliceIframeEmbed.vue?vue&type=script&lang=js"
import style0 from "./SliceIframeEmbed.vue?vue&type=style&index=0&id=6542825f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542825f",
  null
  
)

export default component.exports